module.exports = __webpack_public_path__ + "static/media/Turold.769858cd.md";